/*
 * Copyright © 2025 Gavin Sawyer. All rights reserved.
 */

import { type Environment } from "@bowstring/interfaces";


export const environment: Environment = {
  app:        "website",
  apis:       {
    firebase: {
      apiKey:            "AIzaSyAFzVk_MsuL_bR3zTzN4gPJ5Ld7qjlmbJM",
      appId:             "1:143244626017:web:8992abb350d691f2ae0220",
      authDomain:        "bowstring-55129.firebaseapp.com",
      databaseURL:       "https://bowstring-55129-default-rtdb.firebaseio.com",
      measurementId:     "G-MH7JWNGFNF",
      messagingSenderId: "143244626017",
      projectId:         "bowstring-55129",
      storageBucket:     "bowstring-55129.firebasestorage.app",
    },
    recaptcha: { siteKey: "6LdY0FUrAAAAAIqHFgtesIDSorHaY872NI4OwUBo" },
  },
  domain:     "bowstr.ing",
  production: true,
};
